export enum ExportOptions {
  ALL = "all",
  RANGE = "range"
}
